import "core-js";

import * as $ from "jquery";
import "./easy";

import Blackout from "./Components/Blackout";
import MobileNav from "./Components/MobileNav";

import QualitySlideshow from "./Quality/QualitySlideshow";

$(document).ready(function() {

	{
		const el = <HTMLElement>document.querySelector("quality-slideshow");

		if (el) {
			let data;

			try {
				data = JSON.parse(el.innerHTML);
			} catch(e) {
				console.log(el.innerHTML);
				console.error(e);
			}

			if (data) {
				const slideshow = new QualitySlideshow(data, el);
				slideshow.$bind();
			}
		}
	}

	Blackout.initialize($("#blackout"));

	let nav = new MobileNav(
		$(".toggle-off-canvas"),
		$(".mobile-off-canvas")
	);
});
